import dayjs from "dayjs"
import { Install_Codes as IInstallCodeRaw } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { DeepPartial } from "@/types/helpers"
import { safeDayjs } from "@/helpers/dateHelper"
import { IInstallCodeExtra, IInstallCode } from "./installCode.types"
import { InstallCodeExtra, InstallCode } from "./installCode"

type InstallCodeRaw = DeepPartial<IInstallCodeRaw>

export const InstallCodeParser: IParser<IInstallCode, InstallCodeRaw> = {
  toDomain: (data: InstallCodeRaw): IInstallCode => {
    try {
      return new InstallCode(
        Number(data.id),
        data.msn ?? "",
        dayjs(data.created_at),
        dayjs(data.updated_at),
        data.meter?.type ?? undefined,
        data.meter?.meter_meter_point_rels?.[0]?.meter_point?.identifier ??
          undefined,
        safeDayjs(data.asn_date),
        data.asn_outcome ?? undefined,
        data.comment ?? undefined,
        data.device_id ?? undefined,
        data.install_code ?? undefined,
        safeDayjs(data.last_date_checked),
        data.map_id ?? undefined,
        data.map_name ?? undefined,
        safeDayjs(data.requested_date),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}

export const InstallCodeExtraParser: IParser<
  IInstallCodeExtra,
  InstallCodeRaw
> = {
  toDomain: (data: InstallCodeRaw): IInstallCodeExtra => {
    try {
      return new InstallCodeExtra(
        InstallCodeParser.toDomain(data),
        data.cs_dashboard?.manufacturer ?? undefined,
        data.cs_dashboard?.model ?? undefined,
        data.cs_dashboard?.gbcs_version ?? undefined,
        data.cs_dashboard?.smets_version ?? undefined,
        data.cs_dashboard?.firmware_version ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
